import React, { useState, useContext } from 'react'
import bgImg from '../../../Image/dreamstars_bg.png';
import logoImg from '../../../Image/dreamstars_logo.png'
import { Link, useNavigate } from "react-router-dom";
import otp from '../../../favicon/otp.png'
import lockimg from '../../../Image/lock.png';
import { APIRequest, ApiUrl } from '../../../Helpers/ApiHelper';
import customValidation from '../../../Helpers/customValidation';
import { Notification, Placeholder, useToaster } from 'rsuite';
import ErrorHelper from '../../../Helpers/ErrorHelper'
import CustomLoader from '../../comman/Loader/CustomLoader';
import { Auth } from '../../../Contexts/AuthContext';
import backButton from '../../../Image/backButton.svg'
import Footer from '../../comman/Footer';



const ResetInfulencerPassword = () => {
  const navigate = useNavigate();
  const toaster = useToaster();
  const { formData, setFormData } = useContext(Auth);
  const [isLoading, setIsLoading] = useState(false);
  const [validataionErrors, setValidataionErrors] = useState([])

  const changeInput = (e) => {
    const name = e.target.name;
    if (name === 'otp') {
           
      if (!customValidation.isPositveIntegerNumber(e?.target?.value)) {
          return false;
      }
  }
    const value = e.target.value;
    const collect = {
      ...formData,
      [name]: value
    };
     
    const IsError = validataionErrors?.find(v => v.field == name);
        console.log("is : ", IsError);
        if (IsError !== undefined) {
            const errors = validataionErrors?.filter(v => v.field !== name);
            setValidataionErrors(errors);
        }

    setFormData(collect);
  }

  const handleSubmit = (e) => {
    setIsLoading(true);
    e.preventDefault();
    setFormData(" ");
    let config = {
      url: ApiUrl.resetPasswordInfulencer,
      method: 'post',
      body: {
        otp: formData?.otp,
        password: formData?.password,
        password_confirmation: formData?.password_confirmation,
        device_token: '',
      },
    };

    APIRequest(
      config,

      res => {
        setIsLoading(false);
        if (res?.success) {
          navigate("/")
        }
        toaster.push(<Notification type="success" header="Success" >
          <Placeholder.Paragraph type="success" header="Success" style={{ width: 100, color: 'red' }} rows={0} />{res?.message}</Notification>
          , {
            placement: 'topEnd'
          });


      },
      err => {
        setIsLoading(false);
        if (err.response.status === 422) {
          setValidataionErrors(err?.response?.data?.errors);

        } else if (err.response.status === 401) {
          toaster.push(<Notification type="error" header="Error" >
            <Placeholder.Paragraph type="error" header="Error" style={{ width: 100, color: 'red' }} rows={0} />{err?.response?.data?.message} Kindly type a correct OTP</Notification>
            , {
              placement: 'topCenter'
            });
        }

        else {
          alert(err?.message)
        }
      },
    );

  }



  return (
    <>
      <CustomLoader visible={isLoading}/>
      <div className=" mainBg w-screen min-h-screen bg-cover bg-center bg-no-repeat flex justify-center items-center" >

        <img onClick={() => { navigate("/influencer/forgot-password") }} src={backButton} alt="backButton-img" className=" cursor-pointer absolute top-5 left-8" />



        <form onSubmit={handleSubmit} className=' flex flex-col login-form font-museob w-[300px] sm:w-[440px] lg:w-[480px]' >
          <div className='h-[47px] flex items-center rounded-full' style={{ boxShadow: 'rgba(50, 50, 93, 0.25) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px', width: "100%", borderRadius: "8px" }}>
            <div className='rounded-l-lg h-full w-[18%]  bg-white  flex justify-center items-center' ><img src={otp} className="w-7" alt="otp_img"  ></img></div>
            <input onChange={changeInput} className="border-none outline-none rounded-r-lg  h-full w-full placeholder:pr-[18%]  placeholder:text-center placeholder:text-slate-300" value={formData?.otp !==undefined ? formData?.otp : ''} type="text" name="otp" id="otp" placeholder="OTP" required  ></input>
          </div>
          {ErrorHelper(validataionErrors, "otp")}



          <div className='h-[47px]  flex items-center mt-2 rounded-full' style={{ boxShadow: 'rgba(50, 50, 93, 0.25) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px', width: "100%", borderRadius: "8px" }}>
            <div className='rounded-l-lg  h-full w-[18%]  bg-white flex justify-center items-center'><img src={lockimg} className="w-6" alt="lock_img" ></img></div>
            <input onChange={changeInput} className="border-none outline-none rounded-r-lg  h-full w-full  placeholder:pr-[18%]  placeholder:text-center placeholder:text-slate-300" value={formData?.password !==undefined ? formData?.password : ''} type="password" name="password" id="password" placeholder="Password" required  ></input>
          </div>
          {ErrorHelper(validataionErrors, "password")}



          <div className='h-[47px]  flex items-center mt-2 rounded-full' style={{ boxShadow: 'rgba(50, 50, 93, 0.25) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px', width: "100%", borderRadius: "8px" }} >
            <div className='rounded-l-lg  h-full w-[18%]  bg-white flex justify-center items-center'><img src={lockimg} className="w-6" alt="lock_img" ></img></div>
            <input onChange={changeInput} className="border-none outline-none rounded-r-lg h-full w-full placeholder:pr-[18%] placeholder:text-center placeholder:text-slate-300 " value={formData?.password_confirmation !==undefined ? formData?.password_confirmation : ''} type="password" name="password_confirmation" id="password_confirmation" placeholder="Confirm Password" required ></input>
          </div>
          {ErrorHelper(validataionErrors, "password_confirmation")}

          <div className='w-full flex justify-center  items-center' >
            <button style={{ boxShadow: 'rgba(50, 50, 93, 0.25) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px' }}
              type="submit" id='submit' className='btn-anim i bg-[#00B048] w-[200px] lg:w-[268px] h-[47px] rounded-lg  mt-4 text-white font-museobb '>CONTINUE</button>
          </div>

        </form>


        <div className='absolute bottom-0' ><Footer colorClass="footerColor2" clas="footer"  /></div>


      </div>
    </>

  )
}

export default ResetInfulencerPassword
